import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Eyebrow from "../common/Eyebrow";

const NotFound = () => {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 py-24 text-center">
      <Helmet>
        <title>Page Not Found - QuantaRock</title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      <Eyebrow className="text-sm">404</Eyebrow>
      <h1 className="mt-4 text-3xl font-bold text-[var(--website-primary-color)] sm:text-4xl">
        Page not found
      </h1>
      <p className="mt-4 max-w-md text-slate-600">
        The page you're looking for doesn't exist or may have been moved.
      </p>
      <Link
        to="/"
        className="mt-8 rounded-lg bg-[var(--website-primary-color)] px-6 py-3 font-semibold text-white transition hover:opacity-90"
      >
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
